import { useState } from 'react'
import { MembersListPage } from '@/components/members/members-list-page'
import { PageHeader, PageShell } from '@/components/portal/page-header'
import { Button } from '@/components/ui/button'
import { InviteMemberModal } from '@/components/members/invite-member-modal'

export function OperationsMembers() {
  const [inviteOpen, setInviteOpen] = useState(false)

  return (
    <PageShell>
      <PageHeader
        title="Members"
        label="Management"
        description="Invite and manage member accounts and plot assignments."
        action={
          <Button type="button" onClick={() => setInviteOpen(true)}>
            Invite member
          </Button>
        }
      />

      <InviteMemberModal open={inviteOpen} onClose={() => setInviteOpen(false)} />

      <MembersListPage basePath="/operations/members" showInvite={false} hideHeader />
    </PageShell>
  )
}
